import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import useApi from '../../hooks/useApi';
import getLogo from '../../utils/getLogo';
import './LogoForm.css';

const LogoForm = ({ target }) => {
    const { t } = useTranslation();
	const method = '/logo';
    const [ type, setType ] = useState('fake');
    const [ params, setParams ] = useState({});
	const [ data, error, isLoading ] = useApi({ type, method, params });
	const [ logo, setLogo ] = useState('');
    const [ targetType, setTargetType ] = useState('unknown');
    const [ targetId, setTargetId ] = useState('unknown');

	useEffect(() => {
        if(target.event) {
            setTargetType('event');
            setTargetId(target.event._id);
            if(target.event.logo) {
                setLogo(getLogo(target.event));
            }
        } else if(target.exhibitor) {
            setTargetType('exhibitor');
            setTargetId(target.exhibitor._id);
            if(target.exhibitor.logo) {
                setLogo(getLogo(target.exhibitor));
            }
        }
	}, [target]);

    useEffect(() => {
        if(data) {
            setLogo(getLogo(data));
        }
    }, [data]);

    const onFileChange = (e) => {
        const file = e.target.files[0];
        if(!file) return;
        const formData = new FormData();
        formData.append('logo', file, file.name);
        formData.append(targetType, targetId);
        setParams(formData);
        setType('post');
    };

	return (
		<div className='LogoForm'>
	        {isLoading && <div className='LogoForm-wait'>{t('common.loading')}</div>}
	        {error && <div className='LogoForm-error'>{t(error)}</div>}
            <div className='LogoForm-info'/>
            <div className='LogoForm-logo' style={logo ? { backgroundImage: 'url('+logo+')'} : null}/>
	        <label htmlFor='logo'/>
	        <input
                id='logo'
                type='file'
                accept='image/jpeg, image/png, image/gif'
                onChange={onFileChange}
            />
		</div>
	);
};

LogoForm.propTypes = {
    target: PropTypes.object.isRequired,
};

export default LogoForm;
